export type Role = 'driver' | 'leder'

export interface CommentEntry {
  id: string
  role: Role
  text: string
  dateKey: string
  dayLabel: string
  timeRange: string
  sortKey: number
  userId: string
  userName: string
  /** Who performed the approval this comment belongs to. */
  approverName: string | null
}

export interface CommentDayGroup {
  /** Unique key for the group: `${dateKey}` for single-user, `${dateKey}-${userId}` for multi-user. */
  key: string
  dateKey: string
  dayLabel: string
  /** Set when multiple users' comments are present in the source list. */
  userName: string | null
  items: CommentEntry[]
}

export const LONG_COMMENT_THRESHOLD = 160
